import React, { Fragment } from "react";
import Logomarca from "../../assets/logo.png"
import { Container, Item, Logo, Copyright } from "./styles";
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaWhatsapp } from "react-icons/fa";

const Footer = () => {
  return (
    <Fragment>
        <Container>
            <Logo>
                <Link to="/"><img src={Logomarca} alt=""/></Link>
                <p>CRECI 12236</p>
            </Logo>
            <Item>
                <h3>Contato</h3>
                <ul>
                    <li>
                    <a href="https://www.facebook.com/profile.php?id=100086292499793" target="_blank" rel="noopener noreferrer">
                        <span><FaFacebook size={32} /> Facebook</span>
                    </a>
                    </li>
                    <li>
                    <a href="https://www.instagram.com/myhomeinvestimentos" target="_blank" rel="noopener noreferrer">
                        <span><FaInstagram size={32} /> Instagram</span>
                    </a>
                    </li>
                    <li>
                    <a href="https://api.whatsapp.com/send?phone=5565999860053" target="_blank" rel="noopener noreferrer">
                        <span><FaWhatsapp size={32} /> Whatsapp</span>
                    </a>
                    </li>
                </ul>
            </Item>
            <Item>
                <h3>Links úteis</h3>
                <ul>
                    <li><Link to="/privacidade"><span>Política de privacidade</span></Link></li>
                </ul>
            </Item>

        </Container>
        <Copyright>
            <p>Todos os direitos reservados.</p>
            <ul>
                <li>
                    <a href="https://criasitepro.com/" target="_blank" rel="noopener noreferrer">
                        <span>Desenvolvido por Cria Site PRO - 2025</span>
                    </a>
                    </li>
            </ul>
        </Copyright>
    </Fragment>

  )
}

export default Footer;